// reactstrap components
import { Container, Col, Row, Button } from "reactstrap";

import React from "react";
import ParticleBackground from "components/Particles";
import { EVENT_LOCATION, CONFERENCE_DATE, WORKSHOPS_DATE } from "../../constants";

function LandingPageHeader({ home }) {
  const size =
    document.body.clientWidth >= 1024 || document.documentElement.clientWidth >= 1024
      ? true
      : false;

  React.useEffect(() => {
    const updateNavbarColor = () => {
      if (document.documentElement.scrollTop > 50 || document.body.scrollTop > 50) {
      } else if (document.documentElement.scrollTop < 300 || document.body.scrollTop < 300) {
      }
    };

    window.addEventListener("scroll", updateNavbarColor);

    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  });

  return (
    <div
      style={{
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: `url(${require(
            `assets/images/${size ? "1920x1080.png" : "1920x10801.png"}`,
          )}), url(${require(`assets/images/${size ? "background1.png" : "background1.png"}`)})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "cover",
          zIndex: 0,
        }}
      />
{/* 
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1,
          pointerEvents: "none",
        }}
      /> */}

      <div
        style={{
          position: "relative",
          zIndex: 2,
          paddingTop: "5rem",
          overflow: "hidden",
          backgroundColor: "transparent",
        }}
        className="page-header"
      >
        <Container style={{ marginTop: !size && "-1rem" }}>
          <Row className="justify-content-center">
            <Col md={6} xs={12}>
              <img
                src={require(`assets/images/logo/elogo.png`)}
                style={{ maxWidth: size ? "400px" : 320 }}
                width="100%"
                alt="North America Digital Twin 2026"
              />

              <h1
                className="text-700 text-white mt-2"
                style={{
                  fontSize: size ? "2rem" : "1.25rem",
                }}
              >
                {EVENT_LOCATION}
              </h1>
              <div className="d-flex mt-3">
                <div className="mr-4">
                  <div style={{ backgroundColor: "#eb5f6b", padding: "2px" }}>
                    <h1
                      className="text-700 text-white m-0"
                      style={{
                        fontSize: size ? "1.2rem" : "1.25rem",
                        // width: size ? "480px" : "330px",
                      }}
                    >
                      CONFERENCE
                    </h1>
                  </div>
                  <div style={{ display: "flex" }}>
                    <h1
                      className="text-700 text-white m-0 border-right pr-2"
                      style={{
                        fontSize: "3rem",
                        // width: size ? "480px" : "330px",
                      }}
                    >
                      11
                    </h1>
                    <h1
                      className="text-700 text-white m-0 pl-2 align-self-center"
                      style={{
                        fontSize: "1rem",
                        // width: size ? "480px" : "330px",
                      }}
                    >
                      AUG
                      <br />
                      2026
                    </h1>
                  </div>
                </div>

                <div>
                  <div style={{ backgroundColor: "#3eb5ca", padding: "2px" }}>
                    <h1
                      className="text-700 text-white m-0"
                      style={{
                        fontSize: size ? "1.2rem" : "1.25rem",
                        // width: size ? "480px" : "330px",
                      }}
                    >
                      WORKSHOPS
                    </h1>
                  </div>
                  <div style={{ display: "flex" }}>
                    <h1
                      className="text-700 text-white m-0 border-right pr-2"
                      style={{
                        fontSize: "3rem",
                        // width: size ? "480px" : "330px",
                      }}
                    >
                      12
                    </h1>
                    <h1
                      className="text-700 text-white m-0 pl-2 align-self-center"
                      style={{
                        fontSize: "1rem",
                        // width: size ? "480px" : "330px",
                      }}
                    >
                      AUG
                      <br />
                      2026
                    </h1>
                  </div>
                </div>
              </div>

              <br />

              <div className="container-fluid row mt-1">
                <Col lg={12} className="px-0">
                  <Button
                    href="/register"
                    className="rounded-0 navbar-item-custom text-400 text-white px-4"
                    color="info"
                    size="lg"
                    target="_blank"
                    style={{ background: "#C66067" }}
                    rel="noopener noreferrer"
                  >
                    <span
                      style={{
                        color: "#fff",
                        textTransform: "none",
                        fontSize: "20px",
                        fontWeight: 700,
                      }}
                    >
                      REGISTER NOW
                    </span>
                  </Button>{" "}
                  <Button
                    href="/agenda"
                    className="rounded-0 navbar-item-custom text-400 text-white px-4"
                    color="primary"
                    size="lg"
                    target="_blank"
                    style={{ background: "#70AEB8" }}
                    rel="noopener noreferrer"
                  >
                    <span
                      style={{
                        color: "#fff",
                        textTransform: "none",
                        fontSize: "20px",
                        fontWeight: 700,
                      }}
                    >
                      VIEW AGENDA
                    </span>
                  </Button>
                </Col>
              </div>
            </Col>
          </Row>
        </Container>
        <ParticleBackground />
      </div>
    </div>
  );
}

export default LandingPageHeader;
